import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import MainLayout from '../views/MainLayout.vue'
import HomePage from '../views/HomePage.vue'

import TicketSale from '../views/administration/TicketSale.vue'
import Exports from '../views/administration/Exports.vue'
import DriverSettlement from '../views/administration/DriverSettlement.vue'
import Payment from '../views/administration/Payment.vue'
import Saldo from '../views/administration/Saldo.vue'
import RollTracking from '../views/administration/RollTracking.vue'
import PrintLog from '../views/administration/PrintLog.vue'

import LiveTracking from '../views/analytics/LiveTracking.vue'
import LineOverview from '../views/analytics/LineOverview.vue'

import Device from '../views/masterdata/Device.vue'
import User from '../views/masterdata/User.vue'
import Location from '../views/masterdata/Location.vue'
import Version from '../views/masterdata/Version.vue'
import Document from '../views/masterdata/Document.vue'
import Logo from '../views/masterdata/Logo.vue'
import Price from '../views/masterdata/Price.vue'
import TicketType from '../views/masterdata/TicketType.vue'

import ActualData from '../views/bavariatimetable/ActualData.vue'
import Gtfs from '../views/bavariatimetable/Gtfs.vue'

import Profile from '../views/settings/Profile.vue'
import Customer from '../views/settings/Customer.vue'

import Online from '../views/admin/Online.vue'
import DeviceAdmin from '../views/admin/Device.vue'
import NewCustomer from '../views/admin/NewCustomer.vue'
import Stripe from '../views/admin/Stripe.vue'

import Tickets from '../views/shop/Tickets.vue'
import Trips from '../views/shop/Trips.vue'
import Payments from '../views/shop/Payments.vue'
import PayPal from '../views/shop/PayPal.vue'
import Payouts from '../views/shop/Payouts.vue'
import VatRelations from '../views/shop/VatRelations.vue'
import VatRates from '../views/shop/VatRates.vue'
import Vehicles from '../views/shop/Vehicles.vue'
import Tickettemplate from '../views/shop/TicketTemplate.vue'

import Tickettypes from '../views/tariff/Tickettypes.vue'
import Pricelevels from '../views/tariff/Pricelevels.vue'
import Tariffversions from '../views/tariff/Tariffversions.vue'
import Tarifflevels from '../views/tariff/Tarifflevels.vue'
import Tariffzones from '../views/tariff/Tariffzones.vue'

import Orderer from '../views/eticket/Orderer.vue'
import OrderList from '../views/eticket/OrderList.vue'
import ETickets from '../views/eticket/Tickets.vue'

import store from '@/store';
import { restoreSession } from '@/auth/session';
import { wendeFarbschemaAn } from '@/shell/farbschema';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/overview',
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'Übersicht',
        component: HomePage
      },
      {
        path: '/masterdata/devices',
        name: 'Geräte verwalten',
        component: Device
      },
      {
        path: '/masterdata/users',
        name: 'Benutzer verwalten',
        component: User
      },
      {
        path: '/masterdata/locations',
        name: 'Orte verwalten',
        component: Location
      },
      {
        path: '/masterdata/versions',
        name: 'Fahrplan verwalten',
        component: Version
      },
      {
        path: '/masterdata/documents',
        name: 'Dokumente verwalten',
        component: Document
      },
      {
        path: '/masterdata/logo',
        name: 'Logos verwalten',
        component: Logo
      },
      {
        path: '/masterdata/price',
        name: 'Preise',
        component: Price
      },
      {
        path: '/masterdata/tickettypes',
        name: 'Kartenarten',
        component: TicketType
      },
      {
        path: '/administration/ticketsales',
        name: 'Verkäufe',
        component: TicketSale
      },
      {
        path: '/administration/exports',
        name: 'Exporte',
        component: Exports
      },
      {
        path: '/administration/driversettlement',
        name: 'Fahrerabrechnung',
        component: DriverSettlement
      },
      {
        path: '/administration/payments',
        name: 'Zahlungen',
        component: Payment
      },
      {
        path: '/administration/saldo',
        name: 'Saldo',
        component: Saldo
      },
      {
        path: '/administration/rolls',
        name: 'Rollen',
        component: RollTracking
      },
      {
        path: '/administration/printlog',
        name: 'Druckprotokoll',
        component: PrintLog
      },
      {
        path: '/analytics/live',
        name: 'Live Tracking',
        component: LiveTracking
      },
      {
        path: '/analytics/tracks',
        name: 'Fahrplahnübersicht',
        component: LineOverview
      },
      {
        path: '/bavariatimtable/actualdata',
        name: 'Ist-Daten',
        component: ActualData
      },
      {
        path: '/bavariatimtable/gtfs',
        name: 'Google Gtfs',
        component: Gtfs
      },
      {
        path: '/superadmin/online',
        name: 'Online',
        component: Online
      },
      {
        path: '/superadmin/device',
        name: 'DeviceAdmin',
        component: DeviceAdmin
      },
      {
        path: '/superadmin/stripe',
        name: 'Stripe',
        component: Stripe
      },
      {
        path: '/superadmin/newcustomer',
        name: 'Neuer Kunde',
        component: NewCustomer
      },
      {
        path: '/settings/profile',
        name: 'Mein Profil',
        component: Profile
      },
      {
        path: '/settings/customer',
        name: 'Kundeneinstellungen',
        component: Customer
      },
      // Shop
      {
        path: '/shop/Trips',
        name: 'Fahrten',
        component: Trips
      },
      {
        path: '/shop/tickets',
        name: 'Tickets',
        component: Tickets
      },
      {
        path: '/shop/payments',
        name: 'Zahlungen',
        component: Payments
      },
      {
        path: '/shop/paypal',
        name: 'PayPal',
        component: PayPal
      },
      {
        path: '/shop/payouts',
        name: 'Auszahlungen',
        component: Payouts
      },
      {
        path: '/shop/vehicles',
        name: 'Fahrzeugtypen',
        component: Vehicles
      },
      {
        path: '/shop/vatrelations',
        name: 'MwSt-Beziehungen',
        component: VatRelations
      },
      {
        path: '/shop/vatrates',
        name: 'MwSt-Sätze',
        component: VatRates
      },
      {
        path: '/shop/tickettemplates',
        name: 'Ticketvorlage',
        component: Tickettemplate
      },
      // Tariff
      {
        path: '/tariff/tickettypes',
        name: 'Ticketarten',
        component: Tickettypes
      },
      {
        path: '/tariff/tariffversions',
        name: 'Tarifversionen',
        component: Tariffversions
      },
      {
        path: '/tariff/tarifflevels',
        name: 'Tarifstufen',
        component: Tarifflevels
      },
      {
        path: '/tariff/pricelevels',
        name: 'Preisstufen',
        component: Pricelevels
      },
      {
        path: '/tariff/tariffzones',
        name: 'Tarifzonen',
        component: Tariffzones
      },
      {
        path: '/eticket/orderer',
        name: 'Besteller',
        component: Orderer
      }, {
        path: '/eticket/orderlist',
        name: 'Bestellliste',
        component: OrderList
      }, {
        path: '/eticket/tickets',
        name: 'Tickets',
        component: ETickets
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (store.state.isLoggedIn || to.path === "/") return next()
  // nach einem Reload die bestehende Cognito-Sitzung uebernehmen
  if (await restoreSession()) return next()
  next('/')
})

// Die Anmeldung bleibt hell (Farbschema, src/shell/farbschema.js): auch nach dem Abmelden und wenn ein Neuladen ohne
// gültige Sitzung hierher umleitet, nachdem das Inline-Skript in public/index.html schon dunkel gesetzt hat. afterEach
// statt beforeEach: nur bestätigte Wechsel; die Anmeldung wird danach erst gerendert.
router.afterEach(to => {
  if (to.path === "/") wendeFarbschemaAn(false)
})

export default router
